import { render, staticRenderFns } from "./FieldDetail.vue?vue&type=template&id=55d81260"
import script from "./FieldDetail.vue?vue&type=script&lang=js"
export * from "./FieldDetail.vue?vue&type=script&lang=js"
import style0 from "./FieldDetail.vue?vue&type=style&index=0&id=55d81260&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports